/**
 * Color palette for pivot point visualization
 * Follows the design specification for consistent styling
 */

export const PIVOT_COLORS = {
  // Resistance levels (red shades)
  R3: '#FF0000',       // Red
  R2: '#FF8C00',       // Orange
  R1: '#FFD700',       // Yellow
  
  // Pivot point (blue)
  PP: '#0066CC',       // Blue (bold)
  
  // Support levels (green shades)
  S1: '#90EE90',       // Light Green
  S2: '#008000',       // Green
  S3: '#006400',       // Dark Green
  
  // Price line
  PRICE: '#FFFFFF',    // White (on dark theme)
  
  // Area fills (with transparency)
  AREA_RESISTANCE: 'rgba(255, 0, 0, 0.15)',
  AREA_SUPPORT: 'rgba(0, 128, 0, 0.15)',
  AREA_NEUTRAL: 'rgba(255, 215, 0, 0.1)',
} as const;

export const SIGNAL_COLORS = {
  BULLISH_BOUNCE: '#00FF00',          // Green - bullish signal
  BEARISH_REJECTION: '#FF0000',       // Red - bearish signal
  BULLISH_BREAK: '#00FF00',   // Green - bullish breakout
  BEARISH_BREAK: '#FF0000',   // Red - bearish breakdown
  BREAK: '#8B5CF6',           // Purple - legacy generic break (should not occur)
  NEUTRAL_TOUCH: '#808080',           // Gray - informational only
} as const;

export const LINE_WIDTHS = {
  PP: 3,    // Pivot point - bold
  R3: 2,    // Strong levels
  S3: 2,
  R2: 2,    // Medium levels
  S2: 2,
  R1: 2,    // Dashed levels
  S1: 2,
  PRICE: 2,
} as const;

/**
 * Get color for a specific pivot level
 */
export function getLevelColor(level: string): string {
  switch (level.toUpperCase()) {
    case 'R3': return PIVOT_COLORS.R3;
    case 'R2': return PIVOT_COLORS.R2;
    case 'R1': return PIVOT_COLORS.R1;
    case 'PP': return PIVOT_COLORS.PP;
    case 'S1': return PIVOT_COLORS.S1;
    case 'S2': return PIVOT_COLORS.S2;
    case 'S3': return PIVOT_COLORS.S3;
    default: return '#CCCCCC';
  }
}

/**
 * Get color for a specific signal type
 */
export function getSignalColor(type: string): string {
  switch (type.toUpperCase()) {
    case 'BULLISH_BOUNCE': return SIGNAL_COLORS.BULLISH_BOUNCE;
    case 'BEARISH_REJECTION': return SIGNAL_COLORS.BEARISH_REJECTION;
    case 'BULLISH_BREAK': return SIGNAL_COLORS.BULLISH_BREAK;
    case 'BEARISH_BREAK': return SIGNAL_COLORS.BEARISH_BREAK;
    case 'BREAK': return SIGNAL_COLORS.BREAK;
    case 'NEUTRAL_TOUCH': return SIGNAL_COLORS.NEUTRAL_TOUCH;
    default: return SIGNAL_COLORS.NEUTRAL_TOUCH;
  }
}
